import {DeviceParamGatewayV3CronLirisData} from "./device-param-gateway-v3-cron-liris-data";
import {DeviceParamGatewayV3CronLirisSyncTime} from "./device-param-gateway-v3-cron-liris-sync-time";
import {DeviceParamGatewayV3CronPostLirisFileFromGateway} from "./device-param-gateway-v3-cron-post-liris-file-from-gateway";
import {DeviceParamGatewayV3CronGetGatewayConfigByUid} from "./device-param-gateway-v3-cron-get-gateway-config-by-uid";

export class DeviceParamGatewayV3Cron {
    public liris_data: DeviceParamGatewayV3CronLirisData = new DeviceParamGatewayV3CronLirisData();
    public liris_sync_time: DeviceParamGatewayV3CronLirisSyncTime = new DeviceParamGatewayV3CronLirisSyncTime();
    public post_liris_files_from_gateway: DeviceParamGatewayV3CronPostLirisFileFromGateway = new DeviceParamGatewayV3CronPostLirisFileFromGateway();
    public get_gateway_config_by_uid: DeviceParamGatewayV3CronGetGatewayConfigByUid = new DeviceParamGatewayV3CronGetGatewayConfigByUid();
}
